import app from 'flarum/forum/app';
import CustomFooter from './components/CustomFooter';
app.initializers.add('huseyinfiliz-modern-footer', () => {
  app.beforeMount(() => {
    if (document.getElementById('modern-footer')) {
      return;
    }
    const footer = document.createElement('footer');
    footer.id = 'modern-footer';
    document.body.appendChild(footer);
    m.mount(footer, CustomFooter);
  });
});